import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

export default function HotRanking({ items }: { items: MediaItem[] }) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center gap-2">
        <i className="ri-fire-fill text-lg text-accent-500"></i>
        <h2 className="font-heading text-base font-bold text-foreground-900">热播推荐榜</h2>
      </div>
      <ol className="space-y-3">
        {items.map((item, index) => (
          <li key={item.id}>
            <Link to={`/detail/${item.id}`} className="group flex items-center gap-3">
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${
                  index < 3
                    ? "bg-accent-500 text-primary-950"
                    : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </span>
              <div className="h-14 w-10 shrink-0 overflow-hidden rounded bg-background-200">
                <img
                  src={item.poster}
                  alt={`${item.title} 海报`}
                  title={`${item.title} - 555电影网`}
                  className="h-full w-full object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-secondary-600">
                  {item.title}
                </p>
                <p className="mt-0.5 flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="text-accent-600">{item.rating.toFixed(1)}分</span>
                  <span>{item.year}</span>
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}